<app-assign-modal-content
    [activeModal]="activeModal"
    [assignmentCode]="assignmentCode"
    [assignmentName]="assignmentName"
    [type]="type"
></app-assign-modal-content>
